// Storage utilities for Baby Food Tracker

export function loadProgress(storageKey) {
    try {
        const saved = localStorage.getItem(storageKey);
        return saved ? JSON.parse(saved) : {};
    } catch (error) {
        console.error('Error loading progress:', error);
        return {};
    }
}

export function saveProgress(storageKey, progress) {
    try {
        localStorage.setItem(storageKey, JSON.stringify(progress));
    } catch (error) {
        console.error('Error saving progress:', error);
    }
}

// Check if progress has any tried foods
export function hasProgressData(progress) {
    return Object.values(progress).some(tried => tried === true);
}
